import React from 'react';
import PropTypes from 'prop-types';
import './TextAreaField.css';

const TextAreaField = props => (
  <div className="text-area-field">
    {props.title && <div className="text-area-field__title">{props.title}</div>}
    <textarea
      rows={props.rows}
      value={props.value}
      onChange={props.onChange}
      maxLength={props.maxLength}
    />
    {props.required && <span className="text-area-field__required">*</span>}
  </div>
);

TextAreaField.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  title: PropTypes.string,
  rows: PropTypes.number,
  required: PropTypes.bool,
  maxLength: PropTypes.string,
};

TextAreaField.defaultProps = {
  rows: 3,
  required: false,
  maxLength: 1000,
};

export default TextAreaField;



// WEBPACK FOOTER //
// ./src/components/TextAreaField/TextAreaField.jsx